module.exports = __webpack_public_path__ + "static/media/Vector.764eb4f3.svg";